<template>
  <v-container fluid>
    <v-card outlined class="pa-3">
      <v-card-title>
        Allgemeines
      </v-card-title>
      <v-divider />
      <v-form class="mt-3" @submit.prevent="save()">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.name"
              outlined
              label="Bundle Name"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.tax_id"
              outlined
              :items="bundle.taxes"
              item-text="name"
              item-value="id"
              label="Steuer auswählen"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="form.description"
              outlined
              label="Beschreibung"
            />
          </v-col>
          <v-col class="d-flex justify-end" cols=" 12">
            <v-btn type="submit" color="primary">
              Speichern
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <v-card outlined class="pa-3 mt-6">
      <v-card-title>
        <v-row>
          <v-col cols="12" class="mt-2" md="2">
            Items
          </v-col>
          <v-col cols="12" md="7">
            <v-text-field v-model="search" class="mt-0 pt-0" label="Suche">
              <v-icon slot="append">
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="d-flex justify-end">
            <v-btn
              type="button"
              color="primary"
              @click="createItem = true"
            >
              Hinzufügen
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        hide-default-footer
        disable-pagination
        :headers="headers"
        :items="bundleItems"
        :search="search"
      >
        <template #[`item.created_at`]="{ item }">
          {{ getDateString(item.created_at) }}
        </template>
        <template #[`item.actions`]="{ item }">
          <v-icon small @click="bundleItemEditPrompt(item)">
            mdi-pencil
          </v-icon>

          <v-icon @click="deletePrompt(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="editItem" max-width="1000">
      <BundleItemEdit
        :bundle-item="selectedItem"
        @updated="updated()"
      />
    </v-dialog>
    <v-dialog v-model="createItem" max-width="1000">
      <BundleItemCreate
        :items="items"
        :bundle="bundle.id"
        @updated="updated()"
      />
    </v-dialog>
    <v-dialog v-model="deleteItem" max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          Sind Sie sicher dass dieses Item entfernt werden soll?
        </v-card-title>

        <v-card-text>
          Bundle Item - {{ selectedItem.name }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="green darken-1" text @click="deleteItem = false">
            Disagree
          </v-btn>

          <v-btn color="red darken-1" text @click="softDelete()">
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import { formattedDateTimeString } from '@/plugins/formatDate.js'
import BundleItemEdit from '@/Components/Admin/Bundle/Item/Edit'
import BundleItemCreate from '@/Components/Admin/Bundle/Item/Create'
export default {
   name: 'BundleEdit',
   metaInfo () {
      return {
         title: this.title
            ? this.title
            : `Bundle - ${this.bundle.name}`
      }
   },
   components: {
      BundleItemEdit,
      BundleItemCreate
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      bundle: {
         type: Object,
         required: true
      },
      bundleItems: {
         type: Object,
         required: true
      },
      items: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         form: this.$inertia.form({
            name: this.bundle.name,
            tax_id: this.bundle.tax.id,
            description: this.bundle.description
         }),
         headers: [
            { text: '#', value: 'id' },
            { text: 'Name', value: 'name' },
            { text: 'Min', value: 'min' },
            { text: 'Max', value: 'max' },
            { text: 'Standard', value: 'default' },
            { text: 'Erstellungsdatum', value: 'created_at' },
            { text: '', value: 'actions', sortable: false }
         ],
         search: null,
         createItem: false,
         editItem: false,
         deleteItem: false,
         selectedItem: {
            name: '',
            min: '',
            max: '',
            default: '',
            id: null
         }
      }
   },
   methods: {
      save () {
         this.form.patch(this.route('bundle.update', this.bundle.id))
      },
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      },
      bundleItemEditPrompt (item) {
         this.selectedItem = item
         this.editItem = true
      },
      updated () {
         this.editItem = false
      },
      deletePrompt (item) {
         this.selectedItem = item
         this.deleteItem = true
      },
      softDelete () {
         this.$inertia
            .patch(this.route('bundle_item.soft_destroy', this.selectedItem.id))
            .then((response) => (this.deleteItem = false))
      }
   }
}
</script>

<style></style>
